import React, { FC, useEffect, useState } from 'react';

import {
  Container,
  Layer,
  Title,
  Message,
  Button,
  ButtonsWrapper,
} from './styles';

interface AlertModalProps {
  handleOnClose: () => void;
  error: Error;
}

const AlertModal: FC<AlertModalProps> = ({ handleOnClose, error }) => {
  const [errorSanitazed, setErrorSanitazed] = useState<string>('');

  useEffect(() => {
    console.log('❌', error);

    switch (error.message) {
      case 'Network Error': {
        setErrorSanitazed('Erro de conexão');
        break;
      }

      default: {
        setErrorSanitazed(`Ocorreu um problema, tente novamente mais tarde.
        Se o problema persistir entre em contato com a equipe de suporte.
        `);
        break;
      }
    }
  }, [error]);

  return (
    <Layer>
      <Container>
        <Title>Algo deu errado</Title>

        <Message>
          {errorSanitazed || 'Por favor tente novamente mais tarde'}
        </Message>

        <ButtonsWrapper>
          <Button onClick={handleOnClose}>Continuar</Button>
        </ButtonsWrapper>
      </Container>
    </Layer>
  );
};

export default AlertModal;
